import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentDate } from '../../../utils/general'
import { enqueueNotification } from '../../../redux/slices/notificationsSlice'
import { Form } from 'react-final-form'
import { useReportsSalesCommissionsMutation } from '../../../services'
import Header from './components/Header/Header'
import FilteringModal from './components/FilteringModal/FilteringModal'
import { convertDateToString } from '../../../utils/dateUtils'
import SalesCommissionsTableBlock from './components/SalesCommissionsTableBlock/SalesCommissionsTableBlock'
import { UspReportSalesCommissionsResult } from '../../../models'
import { appRoute } from '../../../constants'
import { useNavigate } from 'react-router-dom'
import { getUserAccessRights } from '../../../redux/slices/authSlice'
import { Card, Container } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'

const SalesCommissions = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const userAccess = useSelector(getUserAccessRights)
  const [showTable, setShowTable] = useState(false)
  const [openFilterModal, setOpenFilterModal] = useState(true)
  const [formValues, setFormValues] = useState<any>(null)

  const [filterCommissions, { data: filterData, isSuccess: filterIsSuccess, isLoading: filterIsLoading }] = useReportsSalesCommissionsMutation()

  const handleOpenFilterModal = () => setOpenFilterModal(true)
  const handleCloseFilterModal = () => setOpenFilterModal(false)

  const handleSubmit = (values: any) => {
    const jsonBranchList = values?.Branch?.map((item: any) => ({ BranchID: item?.BranchID }))
    const jsonSalespersonList = values?.Salesperson?.map((item: any) => ({ SalespersonUserID: item?.UserID }))
    filterCommissions({
      uspReportSalesCommissions: {
        asOfDate: getCurrentDate(),
        startDate: convertDateToString(values?.StartDate),
        endDate: convertDateToString(values?.EndDate),
        isBasedOnFinalizedDate: values.isBasedOnFinalizedDate || false,
        isIncludeDeliveredDeals: values.isIncludeDeliveredDeals || false,
        jsonBranchList: jsonBranchList || null,
        jsonSalespersonList: jsonSalespersonList || null,
      },
    })
    setFormValues(values)
  }

  useEffect(() => {
    if (filterIsSuccess) {
      handleCloseFilterModal()
      setShowTable(true)
      dispatch(enqueueNotification({ message: 'Success' }))
    }
  }, [filterIsSuccess])

  useEffect(() => {
    if (!userAccess.CanAccessSalesInsights) {
      dispatch(
        enqueueNotification({
          message:
            'Access Denied: Sorry, your current access rights do not permit you to enter this section. If you believe you should have access, please contact your system administrator or help desk for assistance.',
          options: { variant: 'error' },
        }),
      )
      navigate(appRoute.Home)
    }
  }, [userAccess, appRoute])

  return (
    <Container
      sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CustomBreadcrumbs
        heading='Reports'
        links={[
          {
            href: appRoute.Insights,
            name: 'List',
          },
          {
            name: 'Sales Commissions',
          },
        ]}
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Card
        sx={{
          height: { xs: 800, md: 2 },
          flexGrow: { md: 1 },
          display: { md: 'flex' },
          flexDirection: { md: 'column' },
        }}
      >
        <Form onSubmit={handleSubmit} keepDirtyOnReinitialize initialValues={{ isBasedOnFinalizedDate: false, isIncludeDeliveredDeals: false }}>
          {({ handleSubmit }: any) => (
            <form onSubmit={handleSubmit}>
              {showTable && <Header handleOpenFilterModal={handleOpenFilterModal} filterData={filterData as UspReportSalesCommissionsResult[]} />}
              <FilteringModal formValues={formValues} open={openFilterModal} handleClose={handleCloseFilterModal} />
              {showTable && <SalesCommissionsTableBlock filterData={filterData as UspReportSalesCommissionsResult[]} isLoading={filterIsLoading} />}
            </form>
          )}
        </Form>
      </Card>
    </Container>
  )
}

export default SalesCommissions
